module.exports = __webpack_public_path__ + "fonts/montserrat-v12-latin-600.f6dc6096.woff";